import React from 'react';
import { SVG, SVGIcon } from '../../../atoms/SVG';

export type ButtonIconProps = { text: string; svgSpriteId: SVGIcon };
export function ButtonIcon({ text, svgSpriteId }: ButtonIconProps) {
  return (
    <>
      <span className="invisible">{text}</span>
      <SVG svgSpriteId={svgSpriteId} svgClass="btn__icon" />
    </>
  );
}
